<h2 mat-dialog-title>{{ $title() }}</h2>
<div class="cm-dialog-content" mat-dialog-content [innerHtml]="$message()"></div>
<div mat-dialog-actions align="end">
    @if ($confirmLabel()) {
        <button mat-button [color]="$isDestructive() ? 'warn' : 'primary'" (click)="confirmAction()">{{ $confirmLabel() }}</button>
    }
    @if ($otherActions()) {
        @for (option of $otherActions(); track option.state) {
            <button mat-button (click)="confirmAction(option.state)">{{ option.label }}</button>
        }
    }
    @if ($cancelLabel()) {
        <button mat-button (click)="cancelAction()" autofocus>{{ $cancelLabel() }}</button>
    }
</div>
